import { ApiRequestInterceptor } from "./apiRequest";
import { ORDERS } from "../Constants/Endpoints";

export const fetchChangeActiveRestaurant = async (restauranteId) => {
    const method = "PATCH";
    const url = ORDERS.changeActiveRestaurant.replace("{restauranteId}", restauranteId);
    const response = await ApiRequestInterceptor(url, method); // sin body

    // Normaliza {statusCode, body} o {code, data}
    const status = response?.statusCode ?? response?.code ?? 200;
    const rawBody = response?.body ?? response?.data ?? {};
    const parsed = typeof rawBody === "string" ? JSON.parse(rawBody) : rawBody;

    return {
        statusCode: status,
        body: parsed ?? rawBody,
    };
};